import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import Quote from "@system/config/quote";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';

const SubmitQuotePopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [{ SubmitQuotePopup }, { }, { }] = useDOMAttachToSystemStore();
    const { isOrderBlocked } = props?.data;
    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const inventory = inventoryList;
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const pricing = pricingList;
	

    useEffect(() => {
        if (SubmitQuotePopup) {
            SetStatus(true);
            quoteSubmissionEvent();
        }
    }, [SubmitQuotePopup]);

    const onHide = (action = true) => {
        SetStatus(false)
        if (!isOrderBlocked)
            window.location.href = Quote.getQuoteListingRouteURL()
    };

    function quoteSubmissionEvent() {
      let quoteDetails = SubmitQuotePopup?.data.quoteArr;
      let prodDetails = [];
      quoteDetails.forEach((data,key)=>{
        prodDetails.push(data.product);
      })
      prodDetails.map((data,key)=>{
        let copyObj = {...data};
        copyObj.qas = getInventory(data?.ERPPartNumber)?.qas;
        let pricingDetails = getPricing(
          data.ERPMFRPartNumber || data.erpMfrPartNumber,
          data.ERPPartNumber,
          data.ERPPartNumberModified
        )[0];
        copyObj.priceSource = pricingDetails?.priceSource;
        copyObj.subtotal = pricingDetails?.marketPrice ? pricingDetails.marketPrice * 1000 : 0;
        prodDetails[key] = copyObj;
        
      })
      localStorage.setItem("adobeEventType", "quoteSubmissionEvent");
      if (Object.keys(prodDetails).length) {
        HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
      }
    }

    		   //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
    if (inventory[ERPPartNumber] !== undefined) {
      return inventory[ERPPartNumber];
    }
    return {
      qas: 0,
      quantity: 0,
    };
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };
  
  


    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal model-710">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>

                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">{isOrderBlocked ? 'Contact Us' : 'Quote Submitted'}</h3>
                        </div>
                        <div className="bs5 modal-body text-center">
                            {/**
                             * Ticket #  : 9539
                             * Change #  : Text change when open quote request submitted
                             * Change by : Pankaj
                             * Date      : 02 March 2023 
                             */}
                            {isOrderBlocked ?
                                <>
                                     We are having trouble processing your quote request. There can be various reasons as to why, please reach out to your local Sales Representative 
                                    <p>(indicated under My Contacts, on your Dashboard).</p>
                                </>
                                :
                                <><p><b>Your quote request has been successfully submitted.</b></p>
                                    <span>You will receive an e-mail notification once the status of your quote request has been changed or check it any time online in the quotes overview page.</span></>}

                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button className="bs5 btn btn-primary"
                                onClick={() => { onHide() }}
                            >CLOSE</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default SubmitQuotePopup;